import { useEffect, useState } from 'react';
import api from 'Includes/api/api';

const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
};

const nameLooksLikeAdmin = (value) => String(value || '').trim().toLowerCase().includes('admin');

/** Superuser or a group/role whose name contains "admin". is_staff is ignored. */
export function isSignupAdmin(userInfo) {
  const user = userInfo || readStoredUser();
  if (user?.is_superuser) return true;
  if (nameLooksLikeAdmin(user?.role) || nameLooksLikeAdmin(user?.user_type)) return true;
  if ((user?.groups_names || []).some(nameLooksLikeAdmin)) return true;
  return (user?.groups || []).some((group) => {
    if (typeof group === 'string') return nameLooksLikeAdmin(group);
    if (group && typeof group === 'object') return nameLooksLikeAdmin(group.name);
    return false;
  });
}

export function useSignupAdmin() {
  const [isAdmin, setIsAdmin] = useState(() => isSignupAdmin());

  useEffect(() => {
    if (isSignupAdmin()) {
      setIsAdmin(true);
      return undefined;
    }
    const user = readStoredUser();
    const ids = new Set(
      (Array.isArray(user.groups) ? user.groups : [])
        .map((group) => (group && typeof group === 'object' ? group.id : group))
        .filter((id) => id != null && id !== '')
        .map((id) => String(id))
    );
    if (!ids.size) {
      setIsAdmin(false);
      return undefined;
    }
    let cancelled = false;
    api.get('/users/groups/')
      .then((res) => {
        if (cancelled) return;
        const groups = Array.isArray(res.data?.data) ? res.data.data : [];
        setIsAdmin(groups.some(
          (group) => ids.has(String(group.id)) && nameLooksLikeAdmin(group.name)
        ));
      })
      .catch(() => {
        if (!cancelled) setIsAdmin(false);
      });
    return () => { cancelled = true; };
  }, []);

  return isAdmin;
}
